export function UserListItem({ user, selected, onSelect, c, dark, A }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(user.id)}
      style={{
        width: "100%",
        textAlign: "left",
        border: `1px solid ${selected ? `${A}55` : "transparent"}`,
        borderRadius: 8,
        padding: "10px 11px",
        cursor: "pointer",
        fontSize: 12.5,
        fontWeight: selected ? 600 : 500,
        marginBottom: 2,
        background: selected ? (dark ? `${A}24` : `${A}14`) : "transparent",
        color: c.text,
        borderLeft: `3px solid ${selected ? A : "transparent"}`,
        transition: "all .15s ease",
      }}
      onMouseEnter={(e) => {
        if (!selected) e.currentTarget.style.background = c.hover;
      }}
      onMouseLeave={(e) => {
        if (!selected) e.currentTarget.style.background = "transparent";
      }}
    >
      <div>{user.name}</div>
      <div
        style={{
          fontSize: 11,
          color: c.sub,
          marginTop: 2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {user.email}
      </div>
    </button>
  );
}
